import React, {Component} from 'react';
import './Contribution.css';

function htmlDecode(input){
    var e = document.createElement('div');
    e.innerHTML = input;
    return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
  }

class Contribution extends Component {

    render() {

        var info = this.props.data['info'];
        var title = info['title'];
        var authors = info['authors']['author'];
        var venue = info['venue'];
        var volume = info['volume'];
        var pages = info['pages'];
        var year = info['year'];
        var url = info['url'];

        return <div className="Contribution">
            <div className="Authors">{authors.map((author, i)=>{return htmlDecode(author)+(i<authors.length-1?", ":"")})}</div>
            <div className="Title"><a href={url} target="_blank" rel="noopener noreferrer">{htmlDecode(title)}</a></div>
            <div className="Venue">{venue}{volume!==undefined?"("+volume+")":""}{pages!==undefined?": "+pages+"":""} ({year})</div>
        </div>;

    }
}

export default Contribution;


// WEBPACK FOOTER //
// ./src/Contribution.js